/*
 * BYDEGREE — book landing pages (Astrological Transits, Venus).
 * Small enhancements only; every control works without this file:
 * - mirrors the explorer and zodiac choices into data attributes (for browsers without :has)
 * - starts the line drawings once their section is on screen
 * - keeps the sticky purchase bar above Shopify's cookie banner when it is shown
 */
(function () {
  'use strict';

  function syncChoices(root) {
    root.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches || !input.matches('[data-lp-control]')) return;
      root.setAttribute('data-' + input.getAttribute('data-lp-control'), input.value);
    });
    root.querySelectorAll('[data-lp-control]:checked').forEach(function (input) {
      root.setAttribute('data-' + input.getAttribute('data-lp-control'), input.value);
    });
  }

  document.querySelectorAll('[data-lp-explorer], [data-lp-signs]').forEach(syncChoices);

  // Line drawings start when visible (and are simply shown when motion is reduced)
  var drawn = document.querySelectorAll('.lp');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lp-is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    drawn.forEach(function (section) { observer.observe(section); });
  } else {
    drawn.forEach(function (section) { section.classList.add('lp-is-visible'); });
  }

  // Sticky bar: lift it above the Shopify cookie banner while that banner is open
  var sticky = document.querySelector('[data-lp-sticky]');
  if (sticky) {
    var lift = function () {
      var banner = document.getElementById('shopify-pc__banner');
      var offset = 0;
      if (banner && banner.getClientRects().length) {
        var rect = banner.getBoundingClientRect();
        if (rect.height > 0 && rect.top < window.innerHeight) offset = Math.max(0, window.innerHeight - rect.top);
      }
      sticky.style.setProperty('--lp-sticky-lift', offset + 'px');
    };
    lift();
    window.addEventListener('resize', lift, { passive: true });
    if ('MutationObserver' in window) {
      new MutationObserver(lift).observe(document.body, { childList: true, subtree: false, attributes: true, attributeFilter: ['class', 'style'] });
    }
    setTimeout(lift, 1500);
  }
})();
